import socials from "@suite/config/brand/socials.json";
import icons from "@suite/config/brand/social-icons.json";
import { cn } from "./cn.ts";

interface Social {
  id: string;
  label: string;
  url: string;
}

const ICONS = icons as Record<string, string>;

/** Networks with a URL set in packages/config/brand/socials.json. */
export const SOCIALS: Social[] = (socials as Social[]).filter((s) => s.url);

/**
 * Icon links to the project's social profiles. Renders nothing until at least
 * one URL is filled in packages/config/brand/socials.json — the single place
 * to update them. Icons come from Simple Icons via scripts/fetch-social-icons.mjs.
 */
export function SocialLinks({ className, size = 18 }: { className?: string; size?: number }) {
  if (SOCIALS.length === 0) return null;
  return (
    <nav aria-label="Social" className={cn("flex items-center gap-3.5", className)}>
      {SOCIALS.map((s) => (
        <a
          key={s.id}
          href={s.url}
          rel="me noopener"
          target="_blank"
          aria-label={s.label}
          title={s.label}
          className="inline-flex text-muted transition-colors hover:text-pine"
        >
          <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
            <path d={ICONS[s.id] ?? ""} />
          </svg>
        </a>
      ))}
    </nav>
  );
}
